import { useState, useEffect } from "react";
import { useNavigate,Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import '../../assets/css/dashboard.css';
import '../../assets/css/dashboard-mobile.css';

const HeaderSection = () => {
    const [userDetail, setUserDetail] = useState({
        fname: "Guest",
        lname: "User",
        email: null,
        avatar: null,
    });
    const navigate = useNavigate();
    const { logout } = useAuth();
    //const navigate = useNavigate();
    const [menuActive, setMenuActive] = useState(false);

    // Toggle submenu visibility
    const handleProfileClick = () => {
        setMenuActive(!menuActive);
    };

    // Logout Handler
    const handleLogout = (e) => {
        e.preventDefault();
        logout(navigate);
    };

    useEffect(() => {
        try {
            // Retrieve user details from session storage
            const storedUser = sessionStorage.getItem("user_detail");
            if (storedUser) {
                setUserDetail(JSON.parse(storedUser));
            }

            // Always inject LiveChat script
            const script = document.createElement("script");
            script.innerHTML = `
            window.__lc = window.__lc || {};
            window.__lc.license = 12749676;
            window.__lc.integration_name = "manual_channels";
            window.__lc.product_name = "livechat";
            (function(n,t,c){
                function i(n){return e._h?e._h.apply(null,n):e._q.push(n)}
                var e={_q:[],_h:null,_v:"2.0",
                    on:function(){i(["on",c.call(arguments)])},
                    once:function(){i(["once",c.call(arguments)])},
                    off:function(){i(["off",c.call(arguments)])},
                    get:function(){if(!e._h)throw new Error("[LiveChatWidget] You can't use getters before load.");return i(["get",c.call(arguments)])},
                    call:function(){i(["call",c.call(arguments)])},
                    init:function(){
                        var n=t.createElement("script");
                        n.async=!0;
                        n.type="text/javascript";
                        n.src="https://cdn.livechatinc.com/tracking.js";
                        t.head.appendChild(n)
                    }
                };
                !n.__lc.asyncInit && e.init();
                n.LiveChatWidget = n.LiveChatWidget || e;
            })(window,document,[].slice);
            `;
            document.body.appendChild(script);

            // Cleanup if component unmounts
            return () => {
            if (script) document.body.removeChild(script);
            };
        } catch (error) {
           // console.error("Error retrieving user details:", error);
        }
    }, []);

    return (
        <div className="header-saction">
            <div className="right-header">
                <div className="header-button">
                    {/*<Link to="/customer/dashboard">Dashboard</Link>*/}
                    <Link to="/customer/apps/google-reviews" className={[
                                    '/customer/apps/google-reviews',
                                    '/customer/apps/whats-app-chat',
                                    '/customer/apps/click-to-call',
                                    '/customer/apps/countdown-timer',
                                    '/customer/apps/testimonials',
                                ].includes(window.location.pathname) ? 'active' : ''}>My Apps</Link>
                    <Link to="/customer/catalog" className={[
                                    '/customer/catalog',
                                ].includes(window.location.pathname) ? 'active' : ''}>Catalog</Link>
                    {/*<Link to="/customer/templates" className={[
                                    '/customer/templates',
                                ].includes(window.location.pathname) ? 'active' : ''}>Templates</Link>
                    <Link to="/customer/offers" className={[
                                    '/customer/offers',
                                ].includes(window.location.pathname) ? 'active' : ''}>Offers</Link>*/}
                </div>
                {/*<div className="notifaction-div">
                    <li><Link to="#"><img src={`${process.env.PUBLIC_URL}/images/notifaction-icon-1.png`} alt="Notification 1.png" /></Link></li>
                    <li><Link to="#"><img src={`${process.env.PUBLIC_URL}/images/notifaction-icon-2.png`} alt="Notification 2.png" /></Link></li>
                    <li><Link to="#"><img src={`${process.env.PUBLIC_URL}/images/notifaction-icon-3.png`} alt="Notification 3.png" /></Link></li>
                </div>*/}
                <div className="profile-user">
                    <div className="profile" onClick={handleProfileClick}>
                        <div className="img-box">
                            {userDetail?.avatar ? (
                                <img src={userDetail.avatar} alt="Profile" />
                            ) : (
                                <i className="ph-bold ph-user"></i>
                            )}
                        </div>
                        <div className="user">
                            <h3>{userDetail?.fname+" "+userDetail?.lname}</h3>
                            <p>{userDetail?.email}</p>
                            <i className="fa fa-sort-desc" aria-hidden="true"></i>
                        </div>
                    </div>
                    {/* Submenu */}
                    <div className={`menu ${menuActive ? 'active' : ''}`}>
                        <ul>
                            <li>
                                <Link to="/customer/my-profile"><img src={`${process.env.PUBLIC_URL}/images/profile-icon-1.png`} alt="Countdown Timer" className='silver-icon' /> &nbsp;My Profile</Link>
                            </li>
                            <li>
                                <Link to="/customer/account-setting"><img src={`${process.env.PUBLIC_URL}/images/profile-icon-2.png`} alt="Countdown Timer" className='silver-icon' />&nbsp;Account Settings</Link>
                            </li>
                            <li>
                                <Link to="/customer/billing"><img src={`${process.env.PUBLIC_URL}/images/profile-icon-5.png`} alt="Countdown Timer" className='silver-icon' />&nbsp;Billing</Link>
                            </li>
                            <li>
                                <Link to="/customer/notifications"><img src={`${process.env.PUBLIC_URL}/images/profile-icon-3.png`} alt="Countdown Timer" className='silver-icon' />&nbsp;Notifications</Link>
                            </li>
                            <li>
                                <Link to="#" onClick={handleLogout}><img src={`${process.env.PUBLIC_URL}/images/profile-icon-4.png`} alt="Countdown Timer" className='silver-icon' />&nbsp;Sign Out</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HeaderSection;
